import React from 'react'
import classes from "./style.module.scss"
import CounterComponent from '../../../../component/CounterComponent'

const ContactCards = ({ contactsReceived, contactText, src, color, backgroundColor }) => {
  return (
    <div className={`${classes.card} flex items-center justify-between`} style={{ color, backgroundColor }}>
      <div className=' flex-col h-[97px] justify-between items-end gap-2'>
        <p className={`${classes.text}`}>
          <CounterComponent endValue={contactsReceived} />
        </p>
        <p className={`${classes.fullText}`}>{contactText}</p>
      </div>
      <img src={src} />
    </div>
  )
}

export default ContactCards